import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface ISearchSlice {
  toExport: string[];
}

const initialState: ISearchSlice = {
  toExport: [],
};

export const SearchSlice = createSlice({
  name: "SearchSlice",
  initialState,
  reducers: {
    toggleToExport: (state, action: PayloadAction<string>) => {
      const index = state.toExport.indexOf(action.payload);
      if (index === -1) {
        state.toExport.push(action.payload);
      } else {
        state.toExport.splice(index, 1);
      }
    },
    resetSearchSlice: () => initialState,
  },
});

export const { toggleToExport, resetSearchSlice } = SearchSlice.actions;

export default SearchSlice.reducer;
